<template>
    <div v-if="items" class="index-container" style="position: relative" v-resize="onResize">
        <v-row class="no-frame">
            <v-slide-x-transition>
                <v-col class="no-frame col-3" v-show="show" :style="style">
                    <v-expansion-panels
                        v-model = "expandFilter"
                        style   = "padding-right: 15px;"
                        accordion
                        flat
                    >
                        <v-expansion-panel class="pa-0" :key="1">
                            <div style="height: 13px;"></div>
                            <v-expansion-panel-header :ripple="false" expand-icon="" hide-actions class="pa-0" >
                                <div>
                                    <c-column-header
                                        :label = "title"
                                        class = "primary"
                                        style = "font-size: 16px;"
                                    >
                                        <template v-slot:filter>
                                            <div>
                                                <slot name="pre-filter" />
                                            </div>
                                            <c-item-count :count="count" />
                                            <div>
                                                <a @click.stop="onFilter">
                                                    <v-icon size="18" class="pr-1 white--text">mdi-filter</v-icon>
                                                </a>

                                                <a
                                                    @click.stop = "onRemoveFilter"
                                                    v-show      = "filterOn || (search && search.length > 0)"
                                                >
                                                    <v-icon size="18" class="pr-1 white--text ">mdi-filter-off-outline</v-icon>
                                                </a>
                                            </div>
                                        </template>

                                    </c-column-header>
                                </div>
                            </v-expansion-panel-header>

                            <v-expansion-panel-content eager class="pa-0 pt-1 ma-0 mb-0" style="border-top-left-radius: 0!important; border-top-right-radius: 0!important;">
                                <div>
                                    <slot name="filter"></slot>
                                </div>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>

                    <div class="pb-1 mt-3" v-if="enableSearch">
                        <v-text-field
                            v-model        = "search"
                            autocomplete   = "off"
                            autocorrect    = "off"
                            autocapitalize = "off"
                            spellcheck     = "false"
                            append-icon    = "fas fa-search"
                            ref            = "search"
                            class          = "pt-0 pb-4 mr-4"
                            clearable
                            hide-details
                        />
                    </div>

                    <slot name="pre-index" />
                    <div
                        class="index-block"
                        :style="indexStyle"
                        :key="refreshKey"
                    >
                        <v-virtual-scroll
                            :items="letterlist2"
                            height="height"
                            item-height="30"
                            class="index-scroll"
                            bench="1"
                        >
                            <template v-slot:default="{ item }">
                                <div class="pr-2 mr-1">
                                    <div class="letter-block pl-1" v-if="item.type === 'letter'"
                                         style="width: calc(100% + 10px)"
                                    >
                                        {{ item.value}}
                                    </div>
                                    <div v-if="item.type === 'item'"
                                         class="v-flex pl-3 pl-3"
                                    >
                                        <a @click="onItem(item.value)" class="w-100">
                                            <div
                                                class="pl-2 pr-0 pt-1 v-flex"
                                                style="width: calc(100% + 10px)"
                                                :class="selected && selected.id === item.value.id ? 'item-row-selected' : 'item-row'"
                                            >
                                                <slot name="item" v-bind:item="item.value"></slot>
                                            </div>
                                        </a>
                                    </div>
                                    <div v-if="item.type === 'child'"
                                         class="v-flex pl-3 pl-6"
                                         :class="item.last ? 'last-branch' : 'branch'"
                                    >
                                        <a @click="onItem(item.value)" class="w-100">
                                            <div
                                                class="pl-2 pr-2 pt-1 v-flex"
                                                style="width: calc(100% + 10px)"
                                                :class="selected && selected.id === item.value.id ? 'item-row-selected' : 'item-row'"
                                            >
                                                <slot name="item" v-bind:item="item.value"></slot>
                                            </div>
                                        </a>
                                    </div>
                                </div>
                            </template>
                        </v-virtual-scroll>
                    </div>
                </v-col>
            </v-slide-x-transition>
            <v-col class="no-frame detail-block" :class="show ? 'col-9' : 'col-12'" :style="detailStyle">
                <div
                    class="bxx"
                    v-if="selected && miminize"
                    :style="show ? 'left: calc(25% - 14px)!important;' : 'left: -15px;'"
                >
                    <v-btn
                        fab
                        x-small
                        depressed
                        color="primary"
                        @click="onSide"
                        style="height: 28px;width: 28px;"
                    >
                        <v-icon size="28">{{ show ?  'mdi-chevron-left' : 'mdi-chevron-right' }}</v-icon>
                    </v-btn>
                </div>
                <div :style="'height:' + height + 'px' ">
                    <slot name="detail" v-bind:item="{ item: selected, show: show }"></slot>
                </div>
            </v-col>
        </v-row>
    </div>
</template>

<script>

import CColumnHeader from "@/modules/core/components/utils/CColumnHeader";
import CItemCount    from "@/modules/core/components/utils/CItemCount";

export default {
    name: "CIndex",

    components: {
        CItemCount,
        CColumnHeader
    },

    props: {
        title: {
            required: false,
            type: String,
            default: function () {
                return "Index";
            }
        },

        items: {
            required: false,
            type: Array,
            default: function () {
                return null;
            }
        },

        criterion: {
            required: false,
            type: String,
            default: function () {
                return null;
            }
        },

        children: {
            required: false,
            type: String,
            default: function () {
                return null;
            }
        },

        enableSearch: {
            required: false,
            type: Boolean,
            default: function () {
                return true;
            }
        },

        filter: {
            required: true,
            type    : Function,
        },

        filterOn: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        filterHeight: {
            required: false,
            type    : Number,
            default : function () {
                return 0;
            }
        },

        preIndexHeight: {
            required: false,
            type    : Number,
            default : function () {
                return 0;
            }
        },

        miminize: {
            required: false,
            type    : Boolean,
            default : function () {
                return true;
            }
        },

        heightDiff: {
            required: false,
            type    : Number,
            default : function () {
                return 80;
            }
        }
    },

    data: () => ({
        expandFilter: false,
        search      : null,
        selected    : null,
        show        : true,
        sorted      : [],
        height      : null,
        refreshKey  : 0,
    }),

    watch: {
        items () {
            this.prepare();
        },

        criterion () {
            this.search = this.criterion;
        },

        expandFilter () {
            if (this.expandFilter !== 0) {
                this.refresh();
            }
        }
    },

    mounted() {
        this.prepare(this.items);
        this.onResize();
    },

    computed: {
        count () {
            let count = 0;
            this.letterList.forEach(letter => {
                count += letter.list.length;
                if (this.children) {
                    letter.list.forEach(children => {
                        if (children[this.children]) {
                            count += children[this.children].length;
                        }
                    })
                }
            });

            return count;
        },

        letterlist2 () {
            const list = [];
            this.letterList.forEach(letter => {
                list.push ({
                    type: "letter",
                    value: letter.letter
                });

                letter.list.forEach(item => {
                    list.push({
                        type: "item",
                        value: item
                    });

                    if (this.children) {
                        const children = item[this.children];
                        if (children) {
                            children.forEach((child,index) => {
                                list.push({
                                    type: "child",
                                    value: child,
                                    last : index === children.length - 1,
                                });
                            });
                        }
                    }
                })
            })

            return list;
        },

        letterList () {
            if (!this.sorted) {
                return null;
            }

            if (this.refreshKey < 0) {
                return null;
            }

            const result = [];
            let letter = " ";
            let list   = [];
            let filtered = null;


            if (!this.children) {
                filtered = this.sorted.filter(item => this.filter (item, this.search));
            } else {
                const clone = JSON.parse(JSON.stringify(this.sorted));

                clone.forEach(item => {
                    if (item[this.children] && item[this.children].length > 0) {
                        item[this.children] = item[this.children].filter(child => this.filter(child, this.search));
                    }
                })

                filtered = clone.filter(item => {
                    let hit = this.filter(item, this.search);
                    if (!item[this.children] || item[this.children].length === 0) {
                        return hit;
                    }

                    return item[this.children].length > 0;
                });
            }

            filtered.forEach(item => {
                const upperLetter = item.name.substring (0, 1).toUpperCase();
                if (letter !== upperLetter) {
                    letter = upperLetter;
                    list = [];

                    result.push ({
                        letter: upperLetter,
                        list  : list
                    });
                }

                list.push(item);
            });

            return result;
        },

        indexStyle () {
            const delta = this.expandFilter === 0 ? 55 + this.filterHeight + this.preIndexHeight: 55 + this.preIndexHeight;
            return "height: calc(100% - " + delta + "px);"
        },

        style() {
            return "max-height: " + this.height + "px; min-height:" + this.height + "px;";
        },

        detailStyle() {
            return "max-height: " + this.height + "px; min-height:" + this.height + "px; " + (this.show ? "" : "left: 0");
        }
    },


    methods: {
        refresh() {
            this.refreshKey++;
        },

        onItem (item) {
            if (this.selected  && item.id === this.selected.id) {
                this.selected = null;
                this.$emit("selected", null);
                return;
            }

            this.selected= item;
            this.$emit("selected", item);
        },

        onSide () {
            this.show = !this.show;
            this.$emit("side", this.show)
        },

        onResize () {
            this.height = window.innerHeight-this.heightDiff;
        },

        onFilter () {
            this.expandFilter = this.expandFilter === 0 ? null : 0;
        },

        onRemoveFilter () {
            this.$emit("clear-filter")
            this.$bus.$emit(this.$events.clearFilter);
        },

        setSelected (item) {
            this.selected = item;
        },

        prepare () {
            if (!this.items) {
                return;
            }

            this.sorted = this.items.slice ().sort ((l,r) => {
                if ( l.name.toUpperCase() < r.name.toUpperCase() ){
                    return -1;
                }

                if ( l.name.toUpperCase()  > r.name.toUpperCase() ){
                    return 1;
                }

                return 0;
            });
        },
    }
}
</script>

<style scoped>

.index-block {
    position: relative;
    margin-top: 10px;
}

.index-scroll {
    overflow-y: scroll;
    overflow-x: hidden;
    margin-right: 4px;
}

.detail-block {
    left: 25%;
    min-width: calc(75% - 0px);
    border-left-style: solid;
    border-left-width: 1px;
    border-left-color: black;
    height: 100%;
}

.letter-block {
/*
    height: 30px;
    padding-top: 20px;
    margin-bottom: 10px;

 */
    margin-right: 0;
    border-bottom-style: solid;
    border-bottom-width: 1px;
    border-bottom-color: black;
}

.bxx {
    position: absolute;
    top: 90px;
    z-index: 3;
}

.index-container {
    width: 100%;
    border-top-color: black;
    border-top-style: solid;
    border-top-width: 1px;
    border-bottom-style: solid;
    border-bottom-width: 1px;
}

</style>

<style lang="scss" scoped>

.item-row {
    height: 30px;
}

.item-row-selected {
    height: 30px;
    background-color: #e8e8e8;
}


::v-deep .v-expansion-panel-content__wrap {
    margin: 0;
    padding: 0;
}

::v-deep .v-expansion-panel-header {
    min-height: 10px!important;
}

.branch {
    margin-left: 34px;
    border-left: thin solid lightgrey;
    width: calc(100% - 25px)
}

.branch:before {
    width: 10px;
    height: 12px;
    margin-right: 5px;
    margin-left: -25px;
    vertical-align: top;
    border-bottom: thin solid lightgrey;
    content: "";
    display: inline-block;
}

.last-branch {
    margin-left: 10px;
    width: calc(100% - 11px)
}

.last-branch:before {
    width: 11px;
    height: 16px;
    margin-right: 5px;
    vertical-align: top;
    border-left: thin solid lightgrey;
    border-bottom: thin solid lightgrey;
    content: "";
    display: inline-block;
}

</style>
